(ns nl.mediquest.questionnaire-frontend.config
  (:require
   [adzerk.env :as env]
   [clojure.string :as string]))

(def debug?
  ^boolean goog.DEBUG)

(def version
  "v1")

(def vitaliteitsscan?
  (let [production-url-part "scanvitaliteit"
        ;; [ER, 2025-01-27] will keep supporting old URL for few months (VB-133)
        ;; webserver redirect not available with our DNS provider Previder
        production-url-part-legacy "scanvitaalbedrijf"
        staging-test-url-part "vitaliteitsscan"
        href js/window.location.href]
    (or (string/includes? href production-url-part-legacy)
        (string/includes? href production-url-part)
        (string/includes? href staging-test-url-part))))

(def on-vitaliteitsscan?
  (or (string/starts-with? js/window.location.pathname "/vitaliteitsscan")
      (string/starts-with? js/window.location.pathname "/privacy")))

(env/def BACKEND_HOST
  (let [backend-url (js/URL. js/window.location)]
    (set! (.-port backend-url) 3334)
    (.-origin backend-url)))
